import { useContentful } from './useContentful.esm.js';

/**
 * Returns true if entry has fields information.
 * It's possible for entry not to have fields information if we just got the id and we would need to do another request to get entry information.
 * @param source Entry to check
 */
function isFullEntryInfo(source) {
    return !!(source === null || source === void 0 ? void 0 : source.fields);
}
/**
 * Return true if we got entry that doesn't have fields info if we got string (entry ID) this should return false
 * @param source Entry to check
 */
function isEntryWithoutInfo(source) {
    return typeof source !== 'string' && !isFullEntryInfo(source);
}
/**
 * Return true if we got entry that doesn't have fields info if we got string (entry ID) this should return false
 * @param source Entry to check
 */
function isEntryWithInfo(source) {
    return typeof source !== 'string' && isFullEntryInfo(source);
}
function useContentfulEngine(_a) {
    var _b;
    var source = _a.source, overrideComponentName = _a.overrideComponentName;
    var contentId = typeof source === 'string' ? source : (_b = source === null || source === void 0 ? void 0 : source.sys) === null || _b === void 0 ? void 0 : _b.id;
    // if source is not a string but we are missing fields it means we need to do request for sub component
    // it also means that depth of tree is bigger than LINK_LEVEL_DEPTH,
    // consider increasing this variable
    if (isEntryWithoutInfo(source)) {
        // eslint-disable-next-line no-console
        console.warn('This entry is not a string, is missing fields, or the LINK_LEVEL_DEPTH was exceeded. If the entry is in draft, publish or remove it. Otherwise, consider increasing LINK_LEVEL_DEPTH variable (max is 10). Entry ID is:', contentId);
        // eslint-disable-next-line no-console
        console.warn('https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/links/retrieval-of-linked-items');
    }
    var sourceEntry = isEntryWithInfo(source) ? source : null;
    var _c = useContentful(contentId, sourceEntry), entryMeta = _c.entryMeta, fields = _c.fields;
    var componentName = overrideComponentName !== null && overrideComponentName !== void 0 ? overrideComponentName : (entryMeta ? entryMeta.contentType.sys.id : undefined);
    return { componentName: componentName, contentId: contentId, fields: fields, isLoading: !fields };
}

export { useContentfulEngine };
//# sourceMappingURL=useNucleobaseEngine.esm.js.map
